import { useCallback, useEffect, useMemo, useState } from 'react';
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Menu,
    MenuItem,
    TextField,
    Typography,
    Select, // Add this import
    InputLabel, // Add this import
    FormControl // Add this import
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Image from '../../components/Image';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axiosInstance from '../../utilities/axios';
import { useMessage } from '../../providers/Provider';
import { Delete } from '@mui/icons-material';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';
import {projectsImg} from "../../services/stickerColor"

const CreateProject  = () => {
    const navigate = useNavigate();
    const { showSuccess, showError } = useMessage();
    const [name, setName] = useState('');
    const [key, setKey] = useState('');
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [confirmDeleteDialogOpen, setConfirmDeleteDialogOpen] = useState(false);

    // New state variables for additional fields
    const [category, setCategory] = useState('');
    const [projectLead, setProjectLead] = useState('');
    const [image, setImage] = useState('');
    const [defaultAssignee, setDefaultAssignee] = useState('');
    const [priority, setPriority] = useState('');
    const [startDate, setStartDate] = useState('');
    const [deadlineDate, setDeadlineDate] = useState('');
    const [ismember, setIsmember] = useState(true);

    const [searchParams] = useSearchParams();
    const projectId = searchParams.get('projectId');

    const buttonText = projectId ? 'Save' : 'Create';
    const method = projectId ? 'PUT' : 'POST';
    const url = projectId ? `/api/v2/projects/${projectId}/update` : "/api/v2/projects/create";
    const successMessage = projectId
        ? 'Project updated successfully'
        : 'Project created successfully';

    const [organizationId, setOrganizationId] = useState("");
    const randomNumber = useMemo(() => {
        return Math.floor(Math.random() * 25) + 1;
    }, []);
    useEffect(() => {
        const id = window.localStorage.getItem('selectedOrganization')
        setOrganizationId(id)
    }, [])
  const userr = useAuthUser() || {};
  useEffect(() => {
    const orgs = JSON.parse(localStorage.getItem("allOrg"));
    const selectedOrgId = localStorage.getItem("selectedOrganization");

    if (!orgs || !selectedOrgId || !userr?._id) {
       // console.log(false);
      return;
    }

    const selectedOrg = orgs.find((org) => org._id === selectedOrgId);

    if (!selectedOrg) {
       // console.log(false);
      return;
    }

    const isMember = selectedOrg.members.includes(userr._id);
    setIsmember(isMember);
     // console.log(isMember);
  }, []);

    const fetchProject = useCallback(async () => {
        try {
            const response = await axiosInstance.get(
                `/api/v2/projects/${projectId}`
            );
            
            const { project } = response.data;
             // console.log('Project data:', project);
            
            if (!project) return showError("Project not found");
            setName(project.projectName);
            setKey(project.projectKey);
            setImage(project.imageURL)    
            // Set new state variables from project data
            setCategory(project.category || '');
            setProjectLead(project.projectLead || '');
            setDefaultAssignee(project.defaultAssignee || '');
            setPriority(project.priority || '');
        setStartDate(project.startDate?.split('T')[0] || ''); // Add this formatting
        setDeadlineDate(project.deadlineDate?.split('T')[0] || ''); // Add this formatting
        } catch (e) {
            if (e instanceof Error) {
                showError(e.message)
            }
        }
    }, [projectId, showError]);

    const handleDelete = useCallback(async () => {
        setDeleteLoading(true);
        try {
            const response = await axiosInstance.delete(
                `/api/v2/projects/${projectId}/delete`
            );
            const { message } = response.data;

            if (!message) return showError(message);

            showSuccess('Project deleted successfully');
            setConfirmDeleteDialogOpen(false);
            setDeleteLoading(false);
            navigate('/list-project');
        } catch (e) {
            if (e instanceof Error) {
                showError(e.message);
                setDeleteLoading(false);
            }
        }
    }, [projectId, showSuccess, showError, navigate]);

    useEffect(() => {
        if (projectId) fetchProject();
    }, [fetchProject, projectId]);
     // console.log();
    
    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const data = projectId ? {
                projectName: name,
                projectKey: key,
                imageURL: image,
                organizationId,
                category,
                projectLead,
                defaultAssignee,
                priority,
                startDate,
                deadlineDate
            } : {
                projectName: name,
                projectKey: key,
                imageURL: projectsImg[randomNumber] ? projectsImg[randomNumber] : "projects/project15.svg",
                organizationId
            };

            const response = await axiosInstance({
                method,
                url,
                data,
            });

            const { message } = response.data;
            if (!message) return showError("Can't create a project");

            showSuccess(successMessage);
            navigate('/list-project');
        } catch (e) {
            if (e instanceof Error) {
                showError(e.message);
            }
        }
    };
    
    return (
        <>
            <Box my={3}>
                {!projectId && (
                    <Box sx={{ my: 3, mt: 3, px: 2 }}>
                        <Grid
                            container
                            spacing={4}
                            display='flex'
                            alignItems='center'>
                            <Grid item xs display='flex' alignItems='center'>
                                <Typography variant='h5'>Project</Typography>
                                <Typography
                                    variant='h5'
                                    color='text.secondary'
                                    sx={{ ml: 1 }}>
                                    {' '}
                                    Details
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                )}
                {projectId && (
                    <Box sx={{ ml: 2, textAlign: 'right' }}>
                    {!ismember && (

   <IconButton
                            onClick={() => setConfirmDeleteDialogOpen(true)}>
                            <Delete fontSize='small' />
                        </IconButton>
                                    
                                    
                                    )}
                     

                        <Menu
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(confirmDeleteDialogOpen)}
                            onClose={() => setConfirmDeleteDialogOpen(false)}>
                            <MenuItem
                                onClick={() =>
                                    setConfirmDeleteDialogOpen(true)
                                }>
                                Delete
                            </MenuItem>
                        </Menu>
                    </Box>
                )}

                <Box mt={4}>
                    <Box 
                            className="flex items-center justify-center"
                    
                    sx={{ textAlign: 'center' }}>
                        {/* { // console.log(projectsImg[randomNumber])} */}
                        <Image
                            name={projectId ? image : (projectsImg[randomNumber] ? projectsImg[randomNumber] : "projects/project15.svg")} 
                            alt='#icon'
                            style={{ height: 100 }}
                        />
                        {/* <Box>
                            <Button
                                variant='outlined'
                                size='small'
                                sx={{ fontSize: '11px', my: 1 }}>
                                Change icon
                            </Button>
                        </Box> */}
                    </Box>
                                    <form onSubmit={handleSubmit}>
                        <Box sx={{ maxWidth: '300px', mx: 'auto', mt: 3 }}>
                            {/* Existing Name and Key fields */}
                            <Box>
                                <Typography variant='caption' color='text.secondary'>
                                    Name
                                </Typography>
                                <TextField
                                    placeholder='Name'
                                    size='small'
                                    name='name'
                                    fullWidth
                                    value={name}
                                    onChange={e => setName(e.target.value)}
                                />
                            </Box>
                            <Box mt={1}>
                                <Typography variant='caption' color='text.secondary'>
                                    Key
                                </Typography>
                                <TextField
                                    placeholder='Key'
                                    name='key'
                                    size='small'
                                    fullWidth
                                    value={key}
                                    onChange={e => setKey(e.target.value)}
                                />
                            </Box>

                            {/* New fields rendered only when editing */}
                            {projectId && (
                                <>
                                    <Box mt={1}>
                                        <Typography variant='caption' color='text.secondary'>
                                            Category
                                        </Typography>
                                        <TextField
                                            placeholder='Category'
                                            size='small'
                                            fullWidth
                                            value={category}
                                            onChange={(e) => setCategory(e.target.value)}
                                        />
                                    </Box>
                                    {/* <Box mt={1}>
                                        <Typography variant='caption' color='text.secondary'>
                                            Project Lead
                                        </Typography>
                                        <TextField
                                            placeholder='Project Lead'
                                            size='small'
                                            fullWidth
                                            value={projectLead}
                                            onChange={(e) => setProjectLead(e.target.value)}
                                        />
                                    </Box>
                                    <Box mt={1}>
                                        <Typography variant='caption' color='text.secondary'>
                                            Default Assignee
                                        </Typography>
                                        <TextField
                                            placeholder='Default Assignee'
                                            size='small'
                                            fullWidth
                                            value={defaultAssignee}
                                            onChange={(e) => setDefaultAssignee(e.target.value)}
                                        />
                                    </Box> */}
               <Box mt={1}>
            <Typography variant='caption' color='text.secondary'>
                Priority
            </Typography>
            <FormControl fullWidth size="small">
                <Select
                    value={priority}
                    onChange={(e) => setPriority(e.target.value)}
                    displayEmpty
                >
                    <MenuItem value="" disabled>
                        Select Priority
                    </MenuItem>
                    <MenuItem value="Low">Low</MenuItem>
                    <MenuItem value="Medium">Medium</MenuItem>
                    <MenuItem value="High">High</MenuItem>
                </Select>
            </FormControl>
        </Box>
                                    <Box mt={1}>
                                        <Typography variant='caption' color='text.secondary'>
                                            Start Date
                                        </Typography>
                                        <TextField
                                            type='date'
                                            size='small'
                                            fullWidth
                                            value={startDate}
                                            onChange={(e) => setStartDate(e.target.value)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Box>
                                    <Box mt={1}>
                                        <Typography variant='caption' color='text.secondary'>
                                            Deadline Date
                                        </Typography>
                                        <TextField
                                            type='date'
                                            size='small'
                                            fullWidth
                                            value={deadlineDate}
                                            onChange={(e) => setDeadlineDate(e.target.value)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Box>
                                </>
                            )}

                            <Button
                                type='submit'
                                size='small'
                                sx={{ mt: 3 , mb: 10 }}
                                variant='contained'>
                                {buttonText}
                            </Button>
                        </Box>
                    </form>       
{/* 
                    <form onSubmit={handleSubmit}>
                        <Box sx={{ maxWidth: '300px', mx: 'auto', mt: 3 }}>
                            <Box>
                                <Typography
                                    variant='caption'
                                    color='text.secondary'>
                                    Name
                                </Typography>
                                <TextField
                                    placeholder='Name'
                                    size='small'
                                    name='name'
                                    fullWidth
                                    value={name}
                                    onChange={e => setName(e.target.value)}
                                />
                            </Box>
                            <Box mt={1}>
                                <Typography
                                    variant='caption'
                                    color='text.secondary'>
                                    Key
                                </Typography>
                                <TextField
                                    placeholder='Key'
                                    name='key'
                                    size='small'
                                    fullWidth
                                    value={key}
                                    onChange={e => setKey(e.target.value)}
                                />
                            </Box>
                            <Button
                                type='submit'
                                size='small'
                                sx={{ mt: 3 }}
                                variant='contained'>
                                {buttonText}
                            </Button>
                        </Box>
                    </form> */}

                </Box>
            </Box>

            <Dialog
                open={confirmDeleteDialogOpen}
                onClose={() => setConfirmDeleteDialogOpen(false)}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'>
                <DialogTitle id='alert-dialog-title'>
                    Confirm Delete
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        Are you sure you want to delete the project?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setConfirmDeleteDialogOpen(false)}
                        color='primary'>
                        Cancel
                    </Button>
                    <Button
                        variant='contained'
                        onClick={handleDelete}
                        disabled={deleteLoading}
                        endIcon={
                            deleteLoading && (
                                <CircularProgress
                                    size='20px'
                                    sx={{ color: 'inherit' }}
                                />
                            )
                        }
                        style={{ backgroundColor: '#ff2121', border: 'none' }}
                        autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default CreateProject;
